import React from "react";
import "./JobOpenings.css";

import { Link } from "react-router-dom";

const jobs = [
  {
    title:
      "PHP Developer With Laravel And CodeIgniter Experience (Internship / Experienced)",

    description:
      "We are looking for a PHP Developer who is dedicated to the craft, writes clean and scalable code, and can build high-quality web applications using Laravel and CodeIgniter frameworks. The candidate should have strong backend development knowledge, problem-solving skills, and the ability to manage scalable projects efficiently.",

    requirements: [
      "2 to 4 years of experience in PHP, Laravel and CodeIgniter",

      "Strong knowledge of HTML5, CSS3, JavaScript and jQuery",

      "Experience with MySQL, MongoDB and PostgreSQL databases",

      "Good understanding of debugging, troubleshooting, website optimization and security standards",

      "Knowledge of coding standards and scalable web application architecture",

      "Ability to handle project planning and technical implementation efficiently",
    ],

    expectations:
      "Write clean and maintainable code, develop scalable applications, maintain databases and application functionality, follow development best practices, troubleshoot issues effectively, and contribute to feature development and deployment.",
  },

  {
    title: "Graphics Designer (Internship / Experienced Required)",

    description:
      "We are looking for a creative Graphic Designer who can create engaging and professional graphics for branding, websites and marketing materials. The candidate should have strong creative skills and the ability to deliver visually appealing designs.",

    requirements: [
      "5+ years of experience in Graphic Designing",

      "Strong knowledge of Photoshop, Illustrator and design tools",

      "Ability to create logos, banners and illustrations",

      "Good understanding of branding, layouts and color combinations",

      "Ability to manage deadlines and client requirements professionally",

      "Creative thinking with attention to visual quality and details",
    ],

    expectations:
      "Create visually appealing designs, maintain professional branding standards, collaborate with teams for creative outputs, develop marketing materials and ensure high-quality graphic content across all platforms.",
  },

  {
    title: "Front End Developer - React JS (Internship / Experienced Required)",

    description:
      "We are looking for a skilled React JS Developer who can build modern, responsive and user-friendly web applications with excellent performance and scalability.",

    requirements: [
      "2 to 5 years of experience in React JS development",

      "Strong knowledge of JavaScript, HTML5 and CSS3",

      "Experience with REST APIs and GraphQL",

      "Knowledge of responsive web application development",

      "Familiarity with scalable frontend architecture",

      "Comfortable working in Agile development environment",
    ],

    expectations:
      "Develop responsive user interfaces, optimize applications for performance and speed, collaborate with backend developers, maintain UI consistency and ensure high-quality user experience across all devices.",
  },

  {
    title:
      "Mobile Application Developer - React Native (Internship / Experienced Required)",

    description:
      "We are looking for a React Native Developer who can develop scalable Android and iOS applications with excellent performance and user experience.",

    requirements: [
      "Strong knowledge of React Native, Redux and JavaScript",

      "Experience in Android and iOS application development",

      "Familiarity with REST APIs, GitHub, XCode and Android Studio",

      "Good logical reasoning and troubleshooting skills",

      "Understanding of scalable mobile application architecture",

      "Ability to manage app deployment and optimization",
    ],

    expectations:
      "Develop scalable mobile applications, improve application performance, handle testing and troubleshooting, maintain code quality and build optimized mobile solutions with excellent user experience.",
  },
];

const JobOpenings = () => {
  return (
    <div className="jobs-page">
      <div className="breadcrumb">
        <Link to="/">Home</Link>

        <span>/</span>

        <p>Job Openings</p>
      </div>

      <div className="jobs-header">
        <h1>
          Job <span>Openings</span>
        </h1>

        <p>Explore exciting career opportunities and grow with us.</p>
      </div>

      <div className="jobs-container">
        {jobs.map((job, index) => (
          <div className="job-card" key={index}>
            <h2>{job.title}</h2>

            <div className="job-section">
              <h3>Job Description</h3>

              <p>{job.description}</p>
            </div>

            <div className="job-section">
              <h3>Requirements</h3>

              <ul>
                {job.requirements.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="job-section">
              <h3>What We Expect From You?</h3>

              <p>{job.expectations}</p>
            </div>

            <button className="apply-btn">Apply Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobOpenings;
